import React from "react";
import { ActionButton } from "./ActionButton";

export function HeaderButton({ className = "", ...restProps }) {
  return (
    <ActionButton
      className={`commission-btn--header-action ${className}`.trim()}
      {...restProps}
    />
  );
}

export default HeaderButton;
